// import { compareBuild } from "semver"
export default {
  install(Vue, options) {
    Vue.prototype.$SignalRjs = {
      SignalRTimes:0,
      SignalRServer:jsonObject.SignalRServer,
      ConnectionID:'',
      Connection:'',
      ManualDisconnected:false,
      IntervalIDQueue:[],
      //連接SignalR
      // ConnectionSignalR(){
      //   var this_ = this
      //   this.Connection = new signalR.HubConnectionBuilder().withUrl(this.SignalRServer).withAutomaticReconnect({
      //     nextRetryDelayInMilliseconds: () => 5000 // 每5秒重試一次，無限重試
      //   }).build();
      //   this.Connection.on("OnConnected",
      //       function (Result) {                
      //         // console.log(this_.IntervalIDQueue)
      //         Vue.prototype.$SignalRjs.SignalRTimes = 0
      //         Vue.prototype.$Vehicle.LastEventTime = ''
      //         this_.ConnectionID = Result;
      //         // Vue.prototype.$Global.Noneactive = ''
      //         // Vue.prototype.$Global.load = false
      //         // this_.ConnectionInvoke(Vue.prototype.$Vehicle.UnitIDsArr)
      //         // var SignalRFrequency = 10000
      //         // if(jsonObject.SignalRFrequency){
      //         //   SignalRFrequency = jsonObject.SignalRFrequency
      //         // }
      //         // for(var i = 0 ; i<this.IntervalIDQueue.length ; i++){
      //         //   clearInterval(this.IntervalIDQueue[i])
      //         // }
      //         // this.IntervalIDQueue = []
      //         // this_.IntervalIDQueue.push(setInterval(() => {
      //         //   this_.ConnectionInvoke(Vue.prototype.$Vehicle.UnitIDsArr)
      //         // }, SignalRFrequency))
      //         // console.log('0')
      //         //console.log(this_.ConnectionID)
      //       }
      //   );
      //   this.Connection.on("OnUnitInfoUpdate",
      //       function (UnitInfos,Events) {
      //         Vue.prototype.$Global.Noneactive = ''
      //         Vue.prototype.$Global.load = false
      //         Vue.prototype.$SignalRjs.SignalRTimes++;
      //         Vue.prototype.$Vehicle.FromSignalR = true
      //         var UnitInfoList = UnitInfos
      //         //車機列表排序
      //         UnitInfoList = Vue.prototype.$Vehicle.UnitInfoSort(UnitInfoList)
      //         //車機狀態
      //         Vue.prototype.$Vehicle.setUnitInfoStatus(UnitInfoList)
      //         //Unit屬性框更新
      //         if(Vue.prototype.$Vehicle.ClickUnitID != undefined || Vue.prototype.$Vehicle.ClickUnitID != ''){
      //           for(var i=0 ; i<Vue.prototype.$Vehicle.UnitInfoList.length ; i++){
      //             if(Vue.prototype.$Vehicle.ClickUnitID == Vue.prototype.$Vehicle.UnitInfoList[i].unitId){
      //               const unit = Vue.prototype.$Vehicle.UnitInfoList[i];
      //               // console.log("新t1:"+Vue.prototype.$Vehicle.UnitInfoList[i].t1)
      //               // console.log("舊t1:"+Vue.prototype.$Vehicle.ClickUnitInfo.t1)
      //               // 檢查 t1~t8 是否全部為 null
      //               let allTNull = true;
      //               for (let j = 1; j <= 8; j++) {
      //                 if (unit['t' + j] != null) {
      //                   allTNull = false;
      //                   break;
      //                 }
      //               }
              
      //               if (allTNull) {
      //                 // 如果全部為 null，保留原來的 t1~t8 和 h1~h8
      //                 for (let j = 1; j <= 8; j++) {
      //                   unit['t' + j] = Vue.prototype.$Vehicle.ClickUnitInfo['t' + j];
      //                   unit['h' + j] = Vue.prototype.$Vehicle.ClickUnitInfo['h' + j];
      //                 }
      //                 unit.coldchainTime = Vue.prototype.$Vehicle.ClickUnitInfo.coldchainTime
      //               }
              
      //               // 指定 ClickUnitInfo
      //               Vue.prototype.$Vehicle.ClickUnitInfo = unit;
      //               Vue.prototype.$Vehicle.ClickUnitInfo.coldchainTime = unit.rtcTime
      //               // console.log(Vue.prototype.$Vehicle.UnitInfoList[i])
      //               setTimeout(() => {
      //                 Vue.prototype.$Global.SetUnitmarkZindex(Vue.prototype.$Vehicle.ClickUnitID)//浮到最上面
      //                 Vue.prototype.$Global.SetDotOn(Vue.prototype.$Vehicle.ClickUnitID)//訊號光
      //               }, 500);
      //               // //表示連線
      //               // if(Vue.prototype.$Vehicle.ClickUnitInfo.cameraStatus == 1){
      //               //   for(var i =0;i<Vue.prototype.$Vehicle.UnitVideoShow.length;i++){
      //               //     if(Vue.prototype.$Vehicle.UnitVideoShow[i].show == 0.3){
      //               //       //重設Camera 圖示
      //               //       Vue.prototype.$Vehicle.setUnitVideoShow()
      //               //       Vue.prototype.$Vehicle.setCameraConnection()
      //               //       break;
      //               //     }
      //               //   }
      //               // }
      //               // //表示離線
      //               // if(Vue.prototype.$Vehicle.ClickUnitInfo.cameraStatus == 0){
      //               //   //重設Camera 圖示
      //               //   Vue.prototype.$Vehicle.setUnitVideoShow()
      //               //   Vue.prototype.$Vehicle.setCameraConnection()
      //               // }
      //               // console.log(Vue.prototype.$Vehicle.ClickUnitInfo )
      //               break;
      //             }
      //           }
      //         }
              // if(Events.length >0){
              //   // console.log(Vue.prototype.$Vehicle.LastEventID)
              //   // console.log(Events[0].eventLogId)
              //   //先以時間排序抓取最後一筆發生的事件
              //   Events = Vue.prototype.$Global.sortByKey(Events,'positionDateTimeGMT').reverse()
              //   // 時間格式設定
              //   // let currenttime = new Date(new Date().toISOString())
              //   for(var i = 0 ; i<Events.length;i++){
              //     //計算離線在差多少時間
              //     // var Eventtime = new Date(Events[i].positionDateTimeGMT +'.000Z' );
              //     // var difference = (((currenttime.getTime() - Eventtime.getTime())/1000/60).toFixed(0)) + ' Min'
              //     // if(((currenttime.getTime() - Eventtime.getTime())/1000/60) < 1 ){
              //     //   difference = (((currenttime.getTime() - Eventtime.getTime())/1000).toFixed(0)) + ' Sec'
              //     // }
              //     // Events[i].differenceTime = difference
              //     if(Events[i].positionDateTimeGMT !=null && Events[i].positionDateTimeGMT!=undefined && Events[i].positionDateTimeGMT!=''){
              //       Events[i].differenceTime = Vue.prototype.$Global.GetDateFromSTring(Events[i].positionDateTimeGMT,Vue.prototype.$Vehicle.TimeZone).split(' ')[1]
              //       Events[i].differenceTime = Events[i].differenceTime.split(':')
              //       Events[i].differenceTime = Events[i].differenceTime[0] + ':' + Events[i].differenceTime[1] 
              //     }
              //     //Event Alert 控制
              //     if((Events[i].positionDateTimeGMT > Vue.prototype.$Vehicle.LastEventTime || Vue.prototype.$Vehicle.LastEventTime == '') && !Vue.prototype.$Vehicle.FirstData){
              //       //顯示紅色框重要事件
              //       Vue.prototype.$Global.EventIDEventAlert(Events[i].reportId,Events[i])
              //     }
              //   }
              //   //判斷有沒有新的Event
              //   if(!Vue.prototype.$Global.showImgexample && Vue.prototype.$Vehicle.LastEventID != Events[0].eventLogId){
              //     Vue.prototype.$Global.EventNewShow = true
              //     Vue.prototype.$Vehicle.LastEventID = Events[0].eventLogId
              //     Vue.prototype.$Vehicle.LastEventTime = Events[0].positionDateTimeGMT
              //   }else{
              //     Vue.prototype.$Vehicle.LastEventID = Events[0].eventLogId
              //     Vue.prototype.$Vehicle.LastEventTime = Events[0].positionDateTimeGMT
              //   }
              // }
      //         Vue.prototype.$Vehicle.setEventInfoColor(Events)
      //         Vue.prototype.$Vehicle.UnitEventInfoList = Events
      //       }
      //   );
      //   this.Connection.onclose(error => { 
      //     if (this.ManualDisconnected) {
      //       this.ManualDisconnected = false;
      //       return;
      //     }
        
      //     console.warn('SignalR 連線斷開:', error);
        
      //     if (this.IsReconnecting) return;
      //     this.IsReconnecting = true;
        
      //     this.ReconnectAttempts = (this.ReconnectAttempts || 0) + 1;
      //     if (this.ReconnectAttempts > 5) {
      //       console.error('❌ 重連超過 5 次，已停止重試');
      //       this.IsReconnecting = false;
      //       return;
      //     }
        
      //     console.log(`🔁 第 ${this.ReconnectAttempts} 次重連，3 秒後嘗試...`);
        
      //     setTimeout(() => {
      //       try {
      //         this.ConnectionSignalR(); // 重建連線物件
      //         setTimeout(() => {
      //           this.ConnectionStart()
      //           .then(() => {
      //             console.log("✅ 重連成功");
      //             this.IsReconnecting = false;
      //             this.ReconnectAttempts = 0; // 重置計數
      //           })
      //           .catch(err => {
      //             console.error("❌ 重連失敗:", err);
      //             this.IsReconnecting = false;
      //           });
      //         }, 1000);
      //       } catch (err) {
      //         console.error("❌ 重連失敗 (同步錯誤):", err.message);
      //         this.IsReconnecting = false;
      //       }
      //     }, 3000);
      //   });        
        
      //   // this.Connection.onclose(function(e){
      //   //   // 關閉時想做的事
      //   // });
      // },
      //處理位置資料
      FixUnitInfoFormat(UnitInfos){
        var UnitInfoList = UnitInfos
        //車機列表排序
        UnitInfoList = Vue.prototype.$Vehicle.UnitInfoSort(UnitInfoList)
        //車機狀態
        Vue.prototype.$Vehicle.setUnitInfoStatus(UnitInfoList)
        //Unit屬性框更新
        if(Vue.prototype.$Vehicle.ClickUnitID != undefined || Vue.prototype.$Vehicle.ClickUnitID != ''){
          for(var i=0 ; i<Vue.prototype.$Vehicle.UnitInfoList.length ; i++){
            if(Vue.prototype.$Vehicle.ClickUnitID == Vue.prototype.$Vehicle.UnitInfoList[i].unitId){
              const unit = Vue.prototype.$Vehicle.UnitInfoList[i];
              // 檢查 t1~t8 是否全部為 null
              let allTNull = true;
              for (let j = 1; j <= 8; j++) {
                if (unit['t' + j] != null) {
                  allTNull = false;
                  break;
                }
              }
              if (allTNull) {
                // 如果全部為 null，保留原來的 t1~t8 和 h1~h8
                for (let j = 1; j <= 8; j++) {
                  unit['t' + j] = Vue.prototype.$Vehicle.ClickUnitInfo['t' + j];
                  unit['h' + j] = Vue.prototype.$Vehicle.ClickUnitInfo['h' + j];
                }
                unit.coldchainTime = Vue.prototype.$Vehicle.ClickUnitInfo.coldchainTime
              }
        
              // 指定 ClickUnitInfo
              Vue.prototype.$Vehicle.ClickUnitInfo = unit;
              Vue.prototype.$Vehicle.ClickUnitInfo.coldchainTime = unit.rtcTime
              setTimeout(() => {
                Vue.prototype.$Global.SetUnitmarkZindex(Vue.prototype.$Vehicle.ClickUnitID)//浮到最上面
                Vue.prototype.$Global.SetDotOn(Vue.prototype.$Vehicle.ClickUnitID)//訊號光
              }, 500);
              break;
            }
          }
        }
      },
      //外部處理事件格式
      FixEventsFormat(Events,SignalRMode){
        //先以時間排序抓取最後一筆發生的事件
        var Events = Vue.prototype.$Global.sortByKey(Events,'positionDateTimeGMT').reverse()
        if(SignalRMode == 1){
          var Events_ = []
          for(var i = 0 ; i<Events.length ; i++){
            for(var j = 0 ;j<Vue.prototype.$Vehicle.UnitIDsArr.length;j++){
              if(Vue.prototype.$Vehicle.UnitIDsArr[j] == Events[i].unitId){
                Events_.push(Events[i])
                break;
              }
            }
          }
          Events = Vue.prototype.$Global.sortByKey(Events_,'positionDateTimeGMT').reverse()
        }
        if(Events.length>0){
          // 時間格式設定
          for(var i = 0 ; i<Events.length;i++){
            if(Events[i].positionDateTimeGMT !=null && Events[i].positionDateTimeGMT!=undefined && Events[i].positionDateTimeGMT!=''){
              Events[i].differenceTime = Vue.prototype.$Global.GetDateFromSTring(Events[i].positionDateTimeGMT,Vue.prototype.$Vehicle.TimeZone).split(' ')[1]
              Events[i].differenceTime = Events[i].differenceTime.split(':')
              Events[i].differenceTime = Events[i].differenceTime[0] + ':' + Events[i].differenceTime[1] 
            }
            if(SignalRMode == 1){
              // console.log(Events)
              //Event Alert 控制
              if((Events[i].positionDateTimeGMT > Vue.prototype.$Vehicle.LastEventTime || Vue.prototype.$Vehicle.LastEventTime == '') && !Vue.prototype.$Vehicle.FirstData){
                //顯示紅色框重要事件
                Vue.prototype.$Global.EventIDEventAlert(Events[i].reportId,Events[i])
              }
            }
          }
          if(SignalRMode == 1){
            //判斷有沒有新的Event
            if(!Vue.prototype.$Global.showImgexample && Vue.prototype.$Vehicle.LastEventID != Events[0].eventLogId){
              Vue.prototype.$Global.EventNewShow = true
              Vue.prototype.$Vehicle.LastEventID = Events[0].eventLogId
              Vue.prototype.$Vehicle.LastEventTime = Events[0].positionDateTimeGMT
            }else{
              Vue.prototype.$Vehicle.LastEventID = Events[0].eventLogId
              Vue.prototype.$Vehicle.LastEventTime = Events[0].positionDateTimeGMT
            }
          }
          Vue.prototype.$Vehicle.setEventInfoColor(Events)
        }
        return Events
      },
      // //SignalR 開始連線
      // ConnectionStart(){
      //   this.Connection.start()
      // },
      // //SignalR 丟資料給後端
      // ConnectionInvoke(Units){
      //   this.Connection.invoke('send',Units)
      //   this.Connection.on("OnUnitInfoUpdate")
      // },
      // //SignalR停止
      // ConnectionStop(){
      //   for(var i = 0 ; i<this.IntervalIDQueue.length ; i++){
      //     clearInterval(this.IntervalIDQueue[i])
      //   }
      //   this.IntervalIDQueue = []
      //   this.ManualDisconnected = true
      //   this.Connection.stop().catch(err => {
      //     console.error("Error stopping connection:", err);
      //   });
      // }
    }
  }
}




// WEBPACK FOOTER //
// ./src/SignalR.js